import { render } from "./VkAuth.vue?vue&type=template&id=3ff31d90"
import script from "./VkAuth.vue?vue&type=script&lang=js"
export * from "./VkAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__